import React from 'react';
import PropTypes from 'prop-types';
import SelectWithSearch from '../components/SelectWithSearch';
import { DEFAULT_FALLBACK_LANGUAGE } from 'Constants/App';

const SelectWithSearchContainer = (props) => {
    const {
        regionOptions,
        defaultSelected, optionsWrapperClass,
        select, showAsDropdown, title, className, id, language,
    } = props;

    const handleFilter = (selected) => {
        try {
            select(selected, id, regionOptions);
        } catch {
            select(false);
            throw new Error('City not found');
        }
    };

    const dispatchSearch = async (selected) => {
        try {
            handleFilter(selected);
        } catch (error) {
            throw new Error(error);
        }
    };

    const destinationsArray = regionOptions.countries ? regionOptions.countries.concat(regionOptions.hotels) : [];

    return (
        destinationsArray && (
            <SelectWithSearch
                options={destinationsArray}
                defaultSelected={defaultSelected}
                dispatchSearch={dispatchSearch}
                optionsWrapperClass={optionsWrapperClass}
                showAsDropdown={showAsDropdown}
                title={title}
                className={className}
                language={language}
            />
        )
    );
};

SelectWithSearchContainer.defaultProps = {
    regionOptions       : {},
    isLoading           : false,
    onFilter            : () => {},
    defaultSelected     : '',
    optionsWrapperClass : '',
    showAsDropdown      : true,
    title               : '',
    className           : '',
    language            : DEFAULT_FALLBACK_LANGUAGE,
};

SelectWithSearchContainer.propTypes = {
    regionOptions       : PropTypes.shape(),
    isLoading           : PropTypes.bool,
    channelId           : PropTypes.string.isRequired,
    defaultSelected     : PropTypes.string,
    select              : PropTypes.func.isRequired,
    optionsWrapperClass : PropTypes.string,
    showAsDropdown      : PropTypes.bool,
    title               : PropTypes.oneOfType([ PropTypes.string, PropTypes.node ]),
    className           : PropTypes.string,
    language            : PropTypes.string,
};

export default SelectWithSearchContainer;
